import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { SelectionSingleType } from '../types';
import css from './Breadcrumbs.scss';

type Props = {
	selection: SelectionSingleType;
};

const Breadcrumbs = (props: Props) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleIsOpen = () => setIsOpen(v => !v);

	useEffect(
		function closeOnSelectionChange() {
			setIsOpen(false);
		},
		[props.selection.id]
	);

	return (
		<div className={cn(css.breadcrumbs, { [css.open]: isOpen })}>
			{props.selection.editableModeProps.inheritance?.parent.slice(-3).map(parent => (
				<div
					className={css.crumb}
					key={`crumb-parent-${parent.path}`}
					onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
						try {
							toggleIsOpen();
							const selected = document.getElementById(props.selection.id)!;
							const clicked = selected.closest(`[data-path="${parent.path}"]`)!;

							clicked.dispatchEvent(
								new MouseEvent(
									'mousedown',
									Object.assign((event as unknown) as MouseEvent, {
										bubbles: true,
										metaKey: true,
										ctrlKey: true,
									})
								)
							);
						} catch (e) {
							console.error((e as any).message);
						}
					}}
				>
					{parent.name}
				</div>
			))}
			<div className={css.crumb} onClick={toggleIsOpen}>
				{props.selection.uiConfig.editorProps.name}
			</div>
		</div>
	);
};

export default Breadcrumbs;
